import React from 'react';
import PropTypes from 'prop-types';

import { pages } from '../Shared/Main';

export const generalCategoriesRouteName = 'generalCategories';
export const deviceTypeRouteName = 'deviceType';
export const mobileDeviceTypeRouteName = 'mobileDeviceType';
export const mobileDeviceOSVersionRouteName = 'mobileDeviceOSVersions';
export const licenseManufacturerRouteName = 'licenseManufacturers';
export const licenseProductNameRouteName = 'licenseProductName';
export const licenseVersionRouteName = 'licenseProductVersion';
export const licenseAttributeRouteName = 'licenseProductAttribute';
export const permissionsRouteName = 'permissions';
export const licenseSettingsRouteName = 'licenseSettings';

const withPermCalc = currentRouteName => WrappedComponent => {
    class WithPermCalc extends React.Component {
        constructor(props) {
            super(props);

            const { perms } = this.props;

            let currentRoute = '';
            switch (currentRouteName) {
                case generalCategoriesRouteName:
                    currentRoute = pages.admin.generalCategories;
                    break;
                case deviceTypeRouteName:
                    currentRoute = pages.admin.deviceType;
                    break;
                case mobileDeviceTypeRouteName:
                    currentRoute = pages.admin.mobileDeviceType;
                    break;
                case mobileDeviceOSVersionRouteName:
                    currentRoute = pages.admin.mobileOSVersion;
                    break;
                case licenseManufacturerRouteName:
                    currentRoute = pages.admin.licenseManufacturer;
                    break;
                case licenseProductNameRouteName:
                    currentRoute = pages.admin.licenseProductName;
                    break;
                case licenseVersionRouteName:
                    currentRoute = pages.admin.licenseProductVersion;
                    break;
                case licenseAttributeRouteName:
                    currentRoute = pages.admin.licenseProductAttribute;
                    break;
                case permissionsRouteName:
                    currentRoute = pages.admin.permissions;
                    break;
                case licenseSettingsRouteName:
                    currentRoute = pages.admin.licenses;
                    break;

                default:
            }

            this.addNewPerm = perms.some(element => element.addNewAccess.includes(currentRoute));
            this.editPerm = perms.some(element => element.editAccess.includes(currentRoute));
        }

        render() {
            return (
                <WrappedComponent
                    addNewPerm={this.addNewPerm}
                    editPerm={this.editPerm}
                    {...this.props}
                />
            );
        }
    }

    WithPermCalc.propTypes = {
        perms: PropTypes.arrayOf(
            PropTypes.shape({
                addNewAccess: PropTypes.arrayOf(PropTypes.string),
                editAccess: PropTypes.arrayOf(PropTypes.string),
            })
        ),
    };

    return WithPermCalc;
};

export default withPermCalc;
